;(function (angular) {
  'use strict'

  angular
    .module('kilo.routes.bpu.edit', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  function RouteConfigurator ($stateProvider) {
    var editState = {
      name: 'bpu.edit',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}/edit',
      resolve: {
        bpu: ['$stateParams', 'BpuManager', function ($stateParams, BpuManager) {
          return BpuManager.getById($stateParams.id, BpuManager.query({
            populate: JSON.stringify([
              {
                path: 'client'
              }
            ])
          }))
        }],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(CustomFieldManager.query().select('bpu', 'model')).then(({ data }) => data)
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/bpu/edit/controllers/bpu-edit.template.html',
          controller: 'BpuEditController',
          controllerAs: 'edit'
        },
        'toolbar@': {
          templateUrl: '/app/modules/bpu/edit/controllers/bpu-edit-toolbar.template.html',
          controller: 'BpuEditToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Modification de BPU',
        parent: 'bpu.list'
      }
    }

    var createState = {
      name: 'bpu.create',
      url: '/create',
      resolve: {
        bpu: ['BpuManager', function (BpuManager) {
          return BpuManager.create()
        }],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(CustomFieldManager.query().select('bpu', 'model')).then(({ data }) => data)
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/bpu/edit/controllers/bpu-edit.template.html',
          controller: 'BpuEditController',
          controllerAs: 'edit'
        },
        'toolbar@': {
          templateUrl: '/app/modules/bpu/edit/controllers/bpu-edit-toolbar.template.html',
          controller: 'BpuEditToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Création de BPU',
        parent: 'bpu.list'
      }
    }

    $stateProvider
      .state(editState)
      .state(createState)
  }
})(window.angular)
